/*
 * Dreamy — sélecteur d'offre (S5) : deux radios stylées en cartes, liées aux variantes Essentiel / Duo.
 * Au changement : input caché `id` du formulaire Dawn, bloc prix (pré-rendu en Liquid), libellé du bouton,
 * barre collante (événement dreamy:offer-change), analytics. L'URL ne change pas au clic (pas de ?variant= ajouté).
 * Priorité au chargement : ?variant= dans l'URL (liens pub) > settings.default_offer (déjà appliqué côté Liquid).
 * Motion (prompt 4) : au choix de l'utilisateur, prix et libellé du bouton changent par fondu croisé vertical
 * (Dreamy.motion.swap : l'ancien texte monte de 6 px et s'efface, le nouveau arrive d'en dessous).
 */
if (!customElements.get('dreamy-offer-selector')) {
  customElements.define(
    'dreamy-offer-selector',
    class DreamyOfferSelector extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.form);
        this.priceTarget = document.getElementById(this.dataset.priceTarget);
        this.titlePriceTarget = document.getElementById(this.dataset.titlePriceTarget);
        this.radios = Array.prototype.slice.call(this.querySelectorAll('input[type="radio"]'));
        try {
          this.offers = JSON.parse(this.querySelector('script[data-offers]').textContent);
        } catch (e) {
          this.offers = {};
        }
        var fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl) {
          var match = this.radios.find(function (r) {
            return r.value === fromUrl && !r.disabled;
          });
          if (match) match.checked = true;
        }
        this.radios.forEach((r) => r.addEventListener('change', () => this.update(true)));
        this.update(false);
      }

      get current() {
        return this.radios.find((r) => r.checked);
      }

      update(fromUser) {
        var radio = this.current;
        if (!radio || !this.form) return;
        var id = radio.value;
        var data = this.offers[id] || {};

        var input = this.form.querySelector('input[name="id"]');
        if (input) input.value = id;

        // Cadeaux de l'offre, joints à la ligne du panier (propriété ; désactivée si l'offre n'en a pas).
        var gifts = this.form.querySelector('[data-dreamy-gifts]');
        if (gifts) {
          gifts.value = data.gifts || '';
          gifts.disabled = !data.gifts;
        }

        this.radios.forEach((r) => {
          var card = r.closest('.dr-offer');
          if (card) card.classList.toggle('is-selected', r.checked);
        });

        var motion = fromUser && window.Dreamy && Dreamy.motion;
        var swap = function (el, apply) {
          if (motion) motion.swap(el, apply);
          else apply();
        };
        var tpl = this.querySelector('template[data-price-for="' + id + '"]');
        var target = this.priceTarget;
        if (tpl && target && target.innerHTML.trim() !== tpl.innerHTML.trim())
          swap(target, function () {
            target.innerHTML = tpl.innerHTML;
          });

        // Prix sous le titre (et ligne Klarna), même principe.
        var tplTitle = this.querySelector('template[data-title-price-for="' + id + '"]');
        var titleTarget = this.titlePriceTarget;
        if (tplTitle && titleTarget && titleTarget.innerHTML.trim() !== tplTitle.innerHTML.trim())
          swap(titleTarget, function () {
            titleTarget.innerHTML = tplTitle.innerHTML;
          });

        var button = this.form.querySelector('[type="submit"]');
        if (button) {
          var label = button.querySelector('span');
          if (label && data.atc && label.textContent.trim() !== data.atc)
            swap(label, function () {
              label.textContent = data.atc;
            });
          if (data.available === false) button.setAttribute('disabled', 'disabled');
          else button.removeAttribute('disabled');
        }

        if (fromUser) {
          if (window.Dreamy && Dreamy.track) Dreamy.track('dreamy_offer_select', { offer: data.offer || id });
        }

        document.dispatchEvent(
          new CustomEvent('dreamy:offer-change', {
            detail: { variantId: id, offer: data.offer, name: data.name, sticky: data.sticky, fromUser: fromUser },
          })
        );
      }
    }
  );
}
